<template>
  <v-layout column>
    <h3 class="mb-4 font-weight-medium mb-4">Profile</h3>
    <p class="body-2">
      Full name -
      <span class="font-weight-medium">{{ getUserDetails.fullName }}</span>
    </p>
    <p class="body-2">
      School name -
      <span class="font-weight-medium">{{ getUserDetails.schoolName }}</span>
    </p>
    <p class="body-2">
      Account Status -
      <span
        class="font-weight-medium"
        :class="getUserDetails.premium ? 'Premium' : 'Free'"
      >{{ getUserDetails.premium ? 'Premium' : 'Free' }}</span>
    </p>
    <p class="body-2" v-if="getUserDetails.joinedAt">
      Joined on -
      <span class="font-weight-medium">{{ getUserDetails.joinedAt | dateFormat }}</span>
    </p>
    <div class="caption points">
      <span class="font-weight-bold">{{getUserDetails.points ? getUserDetails.points : 0 }}</span> Points
    </div>
    <p class="mt-4 font-weight-medium">All time records</p>
    <v-layout>
      <v-flex md4 sm6>
        <v-progress-linear
          class="mb-4"
          color="warning"
          :value="progressBarValue"
          height="8"
          rounded
          striped
        ></v-progress-linear>
      </v-flex>
    </v-layout>
    <p class="caption">
      <span
        class="font-weight-bold"
      >{{ getUserDetails.correctAnswers ? getUserDetails.correctAnswers : 0}}</span> Correct Answers /
      <span
        class="font-weight-bold"
      >{{getUserDetails.submittedQuestions ? getUserDetails.submittedQuestions : 0 }}</span> Total Questions
    </p>
    <p class="caption">
      <span
        class="font-weight-bold"
      >{{getUserDetails.exerciseCompleted ? getUserDetails.exerciseCompleted : 0 }}</span> Exercises Completed
    </p>
  </v-layout>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getUserDetails"]),
    progressBarValue() {
      return (
        (100 / this.getUserDetails.submittedQuestions) *
        this.getUserDetails.correctAnswers
      );
    }
  }
};
</script>

<style>
.Premium {
  color: rgb(219, 161, 0);
  display: inline-block;
  padding: 7px 12px;
  background-color: rgba(253, 243, 182, 0.5);
}

.Free {
  color: rgb(0, 113, 219);
  display: inline-block;
  padding: 7px 12px;
  background-color: rgba(182, 210, 253, 0.5);
}

.points {
  padding: 10px 15px;
  color: #6b9e05;
  border: 1px solid #7fb907;
  display: inline-block;
  width: 110px;
  text-align: center;
}
</style>